"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenItemPreload =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenItemPreload, _React$Component);

  function FullscreenItemPreload() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenItemPreload.prototype;

  _proto.render = function render() {
    var item = this.props.item;
    var idx = this.props.item.idx;
    var size = {
      width: this.props.width ? this.props.width : this.props.item.width + 'px',
      height: this.props.height ? this.props.height : this.props.item.height + 'px'
    };

    var innerStyle = _objectSpread({
      backgroundColor: item.bgColor,
      objectFit: 'contain',
      zIndex: -1
    }, size);

    return item.preload_img && (item.isImage || item.isVideo) && !item.isTransparent ? _react["default"].createElement("div", {
      className: 'fullscreen-preload fullscreen-preload-' + idx,
      key: 'preload_container'
    }, _react["default"].createElement("img", {
      className: 'fullscreen-item fullscreen-item-preload',
      src: item.preload_img,
      style: innerStyle,
      key: 'preload'
    }), this.props.loaded ? false : _react["default"].createElement("div", {
      className: "pro-circle-preloader"
    })) : _react["default"].createElement("div", {
      className: 'fullscreen-preload fullscreen-preload-' + idx,
      key: 'preload_container'
    }, _react["default"].createElement("div", {
      className: 'fullscreen-item fullscreen-item-preload',
      style: innerStyle,
      key: 'preload'
    }));
  };

  return FullscreenItemPreload;
}(_react["default"].Component);

var _default = FullscreenItemPreload;
exports["default"] = _default;